import { Product } from "src/api/client-api/products/useGetOneProduct";
import { Divider } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { IngredientsDataRow } from "./IngredientsDataRow";
import { useProductContext } from "../ProductContext";

type IngredientDataProps = {
    product: Product | undefined;
    scoreId: number;
    unit: string;
};

export const IngredientsData = ({ product, scoreId, unit }: IngredientDataProps) => {
    return product?.productIngredients?.map((productIngredient, index) => {
        return (
            <Fragment key={`ingredient-data-row-${productIngredient.ingredient.id}`}>
                <IngredientsDataRow ingredient={productIngredient.ingredient} scoreId={scoreId} unit={unit} />
                {index < (product?.productIngredients?.length ?? 0) - 1 && <Divider />}
            </Fragment>
        );
    });
};
